import { SmileIcon } from "@/components/icons/smile-icon";
import { BaseModal } from "@/components/modal/base-modal";
import { FilledButton } from "@/components/ui/buttons";
import { useViewportHeight } from "@/hooks/utils/use-viewport-height";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";

interface NutritionInfoModalProps {
  isOpen: boolean;
  onDismiss: () => void;
  title: string;
  description: string;
  buttonText: string;
  onButtonClick: () => void;
}

export const NutritionInfoModal = memo(function NutritionInfoModal({
  isOpen,
  onDismiss,
  title,
  description,
  buttonText,
  onButtonClick,
}: NutritionInfoModalProps) {
  const viewportHeight = useViewportHeight();

  return (
    <BaseModal
      isOpen={isOpen}
      onDismiss={onDismiss}
      backdropDismiss={true}
      initialBreakpoint={272 / viewportHeight}
      breakpoints={[0, 272 / viewportHeight]}
    >
      <div className="p-9 flex flex-col items-center gap-9 pb-10">
        <div className="flex items-center gap-2">
          <SmileIcon className="w-8.5 h-8.5" />
          <h2 className={cn(textVariants.title3)}>{title}</h2>
        </div>
        <p className={cn(textVariants.bodySingleLine, "text-center")}>
          {description}
        </p>

        <FilledButton color="purple" onClick={onButtonClick}>
          {buttonText}
        </FilledButton>
      </div>
    </BaseModal>
  );
});
